<script>
    import ShareRedirect from 'views/components/shareRedirect/ShareRedirect.svelte'

    const { params } = $props()
</script>

<ShareRedirect
    {params}
    collection={Backbone.Collection.activities}
    sourceField="source_activity_id"
    showPathPrefix="/activities/show/"
    notFoundMessage={window.i18n.gettext('This activity could not be found.')}
    selectTitle={window.i18n.gettext('Select an activity')}
></ShareRedirect>
